import React from "react";
import PropTypes from "prop-types";
import ConfirmationDialogComponent from "./confirmationDialog.component";
import { useSelector } from "react-redux";

function ConfirmationDialogContainer({
  isLoading,
  isOpen,
  handleClose,
  handleProceed,
  title,
  description,
  type,
}) {
  const lang = useSelector((state) => state.constant.languages);

  return (
    <ConfirmationDialogComponent
      isLoading={isLoading}
      isOpen={isOpen}
      handleClose={handleClose}
      handleProceed={handleProceed}
      lang={lang}
      title={title}
      description={description}
      type={type}
    />
  );
}

ConfirmationDialogContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleProceed: PropTypes.func.isRequired,
};

export default ConfirmationDialogContainer;
